<ng-container *ngFor="let clientDO of ClientDOListWithRole">
  <ng-container *ngIf="false">
    <!-- Title -->
    <div class="title-emphasis">
      <i class="title-ico anticon user"></i>
      <div>
        <h4 class="p-0 m-0">{{clientDO.roleCd | technicalTranslate}} : {{clientDO | MMSClientData: 'fullName'}}</h4>
        <span class="col-grey-dark">{{ (clientDO | MMSClientData:'dateOfBirth') | date }}</span>
      </div>
    </div>

    <!-- Summary personDO?. -->
    <div class="summary-container">
      <!-- <div>
    <span class="s-c-head" translate>Name</span> {{selectedClient?.personDO?.firstName || '' | translate}} 
    <span *ngIf="selectedClient?.personDO?.firstName == null">-</span>
  </div> -->
      <div>
        <span class="s-c-head" translate>{{'Gender' | MMSTranslate}}</span>
        {{(clientDO | MMSClientData:'genderCd') | technicalTranslate}}
        <span *ngIf="selectedClient?.personDO?.genderCd == null">-</span>
      </div>
      <div>
        <span class="s-c-head" translate>{{'Date of Birth' | MMSTranslate}}</span> {{ (clientDO | MMSClientData:'dateOfBirth') | date }}

      </div>
      <div>
        <span class="s-c-head" translate> {{'Country Of Birth' | MMSTranslate}}</span>
        {{ (clientDO | MMSClientData:'countryOfBirthCd') | technicalTranslate}}
        <span *ngIf="selectedClient?.personDO?.countryOfBirthCd == null">-</span>
      </div>
      <div>
        <span class="s-c-head" translate>{{'Citizenship' | MMSTranslate}}</span>
        {{ (clientDO | MMSClientData:'citizenshipCd') | technicalTranslate}}
        <span *ngIf="selectedClient?.personDO?.citizenshipCd == null">-</span>
      </div>
    </div>

    <h3 class="heading heading-summary" translate>{{'Identity' | MMSTranslate}}</h3>

    <div class="summary-container" *ngFor="let data of (clientDO | MMSClientData:'personIdentityList')">
      <div>
        <span class="s-c-head">{{(data.identityTypeCd | technicalTranslate) || '-'}}</span> {{data.identityNum || '-'}}
      </div>
    </div>
    <div *ngIf="selectedClient?.personDO?.personIdentityList?.length == 0">-</div>
    <h3 class="heading heading-summary" translate>{{'Address' | MMSTranslate}}</h3>
    <div class="summary-container">
      <div *ngFor="let data of (clientDO | MMSClientData:'clientAddressList')">
        <span class="s-c-head">{{(data.typeCd | technicalTranslate) || '' | translate}}</span>
        {{data.addressLine1 || '' | translate }},{{data.addressLine2 || '' | translate}},{{data.addressLine3 || '' | translate}}
      </div>
      <!-- <div>
    <span class="s-c-head">Business</span> Mimic Co. F43, WorkSpaze, East State - 1012
  </div> -->
    </div>
    <nz-divider nzDashed></nz-divider>
  </ng-container>

  <ng-container>
    <!-- Title -->
    <div class="title-emphasis">
      <!-- <i *ngIf="!appMetadataHandler.featureFlags['enableBetaFeatures']" class="title-ico anticon anticon-user"></i> -->
      <img src="/assets/images/ico/person.png" alt="" class="b-r-50-pc" />
      <!-- please change code based on /men/ and /women/ and number -->
      <div>
        <h4 class="p-0 m-0">{{clientDO | MMSClientData: 'fullName'}}</h4>
        <span class="col-grey-dark">{{clientDO.roleCd | technicalTranslate}}</span>
      </div>
    </div>

    <!-- Summary personDO?. -->
    <div class="summary-container">
<!-- 
      <div>
        <span class="s-c-head">{{'Income Group' | MMSTranslate}}</span>
        {{(clientDO.personDO?.personEmploymentList[0]?.yearlyIncomeRangeCd | technicalTranslate) || '-'}}
      </div>       -->
      <div>
        <span class="s-c-head" translate> {{'Country Of Birth' | MMSTranslate}}</span>
        {{ (clientDO | MMSClientData:'citizenshipCd') | technicalTranslate}}
        <!-- <span *ngIf="selectedClient?.personDO?.countryOfBirthCd == null">-</span> -->
      </div>
      <div>
        <span class="s-c-head">{{'CIBIL Score' | MMSTranslate}}</span>
        <nz-progress [nzPercent]="clientDO.cibilScore" nzType="circle" [nzWidth]="42" [nzFormat]="formatCibil"></nz-progress>
      </div>

      <div>
        <span class="s-c-head">Medical Score Risk</span>
        <nz-progress [nzPercent]="medicalRiskScore + i" nzType="circle" [nzWidth]="42" [nzFormat]="formatMedicalRisk"></nz-progress>
      </div>
      <div>
        <span class="s-c-head" translate>{{'Gender' | MMSTranslate}}</span>
        {{(clientDO | MMSClientData:'genderCd') | technicalTranslate}}
        <!-- <span *ngIf="selectedClient?.personDO?.genderCd == null">-</span> -->
      </div>
      <div>
        <span class="s-c-head" translate>{{'Date of Birth' | MMSTranslate}}</span>
        {{ (clientDO | MMSClientData:'dateOfBirth') |  date: "dd MMM yyyy" }}
      </div>

      <div>
        <span class="s-c-head" translate>{{'Occupation' | MMSTranslate}}</span>
        {{((clientDO | MMSClientData:'occupationCd') | technicalTranslate) || '-'}}
      </div>

      <!-- <div class="summary-container">
        <span class="s-c-head" translate>Occupation</span>
        {{(clientDO | MMSClientData:'occupationCd') | technicalTranslate}}
      </div> -->

      <!-- <div>
        <span class="s-c-head" translate>Relationship with Policy Holder</span>
        <span>-</span>
      </div> -->

    </div>

    <h3 class="heading heading-summary" translate>{{'Address' | MMSTranslate}}</h3>
    <div class="summary-container">
      <div *ngFor="let data of (clientDO | MMSClientData:'clientAddressList')">
        <span class="s-c-head">{{(data.typeCd | technicalTranslate) || '' | translate}}</span>
        {{ (clientDO | MMSClientData:'citizenshipCd') | technicalTranslate}}
        {{data.addressLine1 || '' | translate }},{{data.addressLine2 || '' | translate}},{{data.addressLine3 || '' | translate}}
      </div>
      <!-- <div>
      <span class="s-c-head">Business</span> Mimic Co. F43, WorkSpaze, East State - 1012
    </div> -->
    </div>
    <nz-divider nzDashed></nz-divider>
  </ng-container>
</ng-container>